import * as React from "react";
import SafeHtml from "../../../components/Html/SafeHtml";
import Divider from "../UI/Divider/Divider";
import styled, { keyframes, ThemeConsumer } from "styled-components";
import { Device } from "../../../components/device";
import { absoluteURL, addUrlParams } from "../../../util/UrlHelper";
import { VenueItem, RichTextControl, InforbationBarRichTextControl, ButtonListItemControl, ButtonTypes, ButtonPurchaseItem } from "../../../typings/grid";
import { A } from "../GlobalStyle/Utilities";
import Icon from "../Icon/Icon";
import {renderButtonType} from "../../../util/ModuleHelper";

/*
TO DO:
When dark theme add .btn--inverted class on buttons
*/
const InfoBarWrap = styled.section`
    a:not(.btn) {
        ${A}
    }
     .show__venue-icons {
        ${Device.tabletLandscape} {
            margin-top: -19px;
        }
     }
     .show__info {
         a {
             opacity: 0.35;
             &:after {
                 margin: 0 auto;
             }
             &:hover {
                opacity: 1;
             }
         }
     }
    .show-info-bar__cta {
        display: flex;
        align-content: center;
        justify-content: center;

        .show-info-bar__cta__group {
            display: flex;
            flex-direction: column;

            .btn {
                flex: 0 auto;
                min-width: 9rem;
            }
        }

        ${Device.tabletLandscape} {
            order: 10;
        }
    }
`;



const FadeIn = keyframes`
     0% { opacity: 0; transform: scale(0); }
     100% { opacity: 1; transform: scale(1);}
`;

const IconWrap = styled.span`
    display: inline-block;
    svg {
        fill: currentColor;
        stroke: currentColor;
        pointer-events: none;
        animation: ${FadeIn} .15s forwards;
    }
`;

interface InformationBarProps
{
    venues: VenueItem[];
    dates?: string;
    richTexts: Array<RichTextControl | InforbationBarRichTextControl>;
    buttons: (ButtonListItemControl | ButtonPurchaseItem)[];
}

const InformationBar: React.FunctionComponent<InformationBarProps> = (props) =>
{
    const { venues, richTexts, buttons, dates } = props;
    const venueNames: string[] = [];

    const addVenueName = (name: string) =>
    {
        venueNames.push(name);
    };

    const getIconUrl = (url: string, color: string) =>
    {
        if (color.startsWith("#"))
        {
            color = color.substring(1);
        }

        return addUrlParams(new URL(absoluteURL(url)), { tint: color }).toString();
    };
    return <InfoBarWrap>
        <div className="flex flex-wrap justify-center text-center">
            <div className="w-full lg:w-1/5 px-4 mb-4 lg:mb-0 show-info-bar__cta">
                <div className="show-info-bar__cta__group">
                    {buttons.map((button: ButtonTypes, index) =>
                    {
                        return renderButtonType(button, index);
                    })}
                </div>
            </div>
            <div className="w-full lg:w-1/5 px-4 mb-4 lg:mb-0">
                <div className="show__venue-icons mb-2">
                    <ThemeConsumer>
                        {theme => {
                            return venues.map((venue, index) => {
                                // const iconUrl = venue.properties.icon ? getIconUrl(venue.properties.icon.url, theme.color) : "";
                                // addVenueName(venue.name || venue._name || "");
                                // return <IconWrap key={index}><img src={iconUrl} alt={venue.name} className="w-10 h-10 p-2 border mx-2" /></IconWrap>;
                                switch (venue.name) {
                                    case "Scala":
                                        return <IconWrap key={index}><Icon name="scala"
                                                                           className="w-10 h-10 p-2 border mx-2"/></IconWrap>;
                                    case "Store Scene":
                                        return <IconWrap key={index}><Icon name="store-scene"
                                                                           className="w-10 h-10 p-2 border mx-2"/></IconWrap>;
                                    case "Scala Foyer":
                                        return <IconWrap key={index}><Icon name="scala"
                                                                           className="w-10 h-10 p-2 border mx-2"/></IconWrap>;
                                    case "Studio":
                                        return <IconWrap key={index}><Icon name="studio"
                                                                           className="w-10 h-10 p-2 border mx-2"/></IconWrap>;
                                    case "Stiklingen":
                                        return <IconWrap key={index}><Icon name="stiklingen"
                                                                           className="w-10 h-10 p-2 border mx-2"/></IconWrap>;
                                    case "Byen":
                                    case "Ude i byen":
                                        return <IconWrap key={index}><Icon name="pil" className="w-10 h-10"/></IconWrap>;
                                    case "Kampmann Salen":
                                    case "Otto Mønsted Salonen":
                                        return <IconWrap key={index}><Icon name="circle" className="w-10 h-10"/></IconWrap>;
                                }
                            });
                        }
                        }
                    </ThemeConsumer>
                </div>
                <div className="show__venue-names uppercase font-bold text-small">
                    {venueNames.join(" * ")}
                </div>
                <div className="show__dates mb-4 lg:mb-0">
                    <SafeHtml html={dates} />
                </div>
            </div>
            {richTexts.map((richText, index) =>
            {
                const { bodyText, heading } = richText.content.properties;
                return (
                    <div key={index} className="w-full lg:w-1/5 px-4 mb-8 lg:mb-0">
                        {richText.content.contentType === "informationBarRichText" ? <h6>{heading}</h6> : null}
                        <SafeHtml html={bodyText?.markup} />
                    </div>
                );
            })}
        </div>
        <div className="mb-8 md:mb-0 md:mt-6">
            <Divider className="opacity-25" />
        </div>
    </InfoBarWrap>;
};

export default InformationBar;
